import { Button } from "antd";
import moment from "moment";
import React, {
	forwardRef,
	Fragment,
	useRef,
} from "react";
import { useReactToPrint } from "react-to-print";
import { useSelector } from "react-redux";
import _ from "lodash";

const PrintToPdf = forwardRef(({ data, invoiceData, productsKey = "saleInvoiceProduct" }, ref) => {
	return (
		<Fragment>
			<div ref={ref} className='w-[240px] m-auto text-sm'>
				<div className='w-full text-center '>
                    <h3 className='font-bold uppercase !text-lg mt-1'>{invoiceData?.companyName}</h3>
							{invoiceData?.tagLine && <div className='tagline font-semibold'>{invoiceData?.tagLine}</div>}
							{invoiceData?.gst_no && <div className="text-center font-semibold ">{invoiceData?.gst_no}</div>}
							<div className='address'>
								{invoiceData?.address && <span>{invoiceData?.address}</span>} <br /> 
								{invoiceData?.address_l2 && <span>{invoiceData?.address_l2}</span>} <br /> 
								{invoiceData?.phone && <span>{invoiceData?.phone}</span>}
							</div>
							{invoiceData?.email && <div className='email'>{invoiceData?.email}</div>}
							{invoiceData?.website && <div className='website'>{invoiceData?.website} </div>}
				</div>

				<div className='box4'>
					<hr className='hr1' />
					<h3 className='center text-base font-semibold'>PACKING SLIP</h3>
					<hr className='hr1' />
				</div>
<div className='flex justify-between capitalize mt-2'>

      <div className='text-left '>
          {data?.customer?.name && <div>{data?.customer?.name}</div>}
          {(data?.customer?.address || data?.address) && <div>{data?.address ? <span>{data?.address}</span> : <span>{data?.customer?.address}</span>}</div>}
          {data?.customer?.phone && <div>{data?.customer?.phone}</div>}
     </div>
      
      <div style={{width:"110px"}} className='text-left '>
          <div><b>Bill No:</b> {data?.invoicePrefix}{data?.manualId}</div>
          <div className=""><b>Date:</b> {moment(data?.date).format("DD/MM/YYYY")}</div>
          {invoiceData?.Show_time_invoice === true && (<div className=""><b>Time:</b> {moment(data?.time).format("HH:mm:ss")}</div>)}
      </div>
</div>
				<div className='box7 '>
					<table className='table1'>
						<thead>
							<th style={{width:"25px", padding: "2px" }}>Sl</th>
							<th style={{padding: "2px" }}>Product Name</th>
							<th style={{padding: "2px" }}>Quantity</th>
						</thead>
						<tbody>
							{data &&
								_.get(data, productsKey, []).map((d, i) => (
									<tr style={{fontSize:15}} key={d.id}>
										<td style={{width:"25px", padding: "2px"}}>{i + 1}</td>
										<td style={{padding: "2px" }}>{d.product.name}</td>
										<td style={{width:"75px", padding: "2px"}} className="text-center">{d.productQuantity}</td>
									</tr>
								))}
						</tbody>
                        <tfoot className="">
                                   <tr>
										<td style={{width:"25px", padding: "2px"}}>{}</td>
										<td style={{padding: "2px" }} className="text-right pr-2"> Total Qty</td>
										<td style={{width:"75px", padding: "2px", fontSize:15}} className="text-center font-bold">{data?.productQty}</td>
									</tr>
                        </tfoot>
					</table>
				</div>

				<div className='box12'>
					<hr />
					<p className="mt-2">{invoiceData?.footer}</p>
				</div>
			</div>
		</Fragment>
	);
});

const PackingSlip1 = ({ data, productsKey }) => {
	const componentRef = useRef();
	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
	});

	const invoiceData = useSelector((state) => state.accounts.appSettings);

	return (
		<div>
			<div className='hidden'>
				<PrintToPdf ref={componentRef} data={data} productsKey={productsKey} invoiceData={invoiceData} />
			</div>
			{invoiceData && (
				<Button type='primary' shape='round' onClick={handlePrint}>
					Packing Slip 3'Pos
				</Button>
			)}
		</div>
	);
};

export default PackingSlip1;
